import { isLegacyAccount$ } from '@op/services'
import type { Ref } from 'react'
import { forwardRef, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { TestID } from '../../TestID'
import type { OPInputFieldProps } from './createInputField'
import { createInputField } from './createInputField'
import { opPasswordValidator } from './opPasswordValidator'

type PasswordFieldProps = OPInputFieldProps & {
	readonly forceLegacy?: boolean
}

export const PasswordField = forwardRef(
	({ forceLegacy, ...p }: PasswordFieldProps, ref: Ref<HTMLInputElement>) => {
		const isLegacyAccount = useSelector(isLegacyAccount$)
		const isLegacyPasswordField = forceLegacy ?? isLegacyAccount

		const PasswordFieldInput = useMemo(
			() =>
				createInputField(
					{ name: 'password', validate: opPasswordValidator(isLegacyPasswordField) },
					{
						'data-testid': TestID.INPUT_PW_TID$$,
						placeholder: 'form_controls.password.placeholder',
						type: 'password',
					},
				),
			[isLegacyPasswordField],
		)

		return <PasswordFieldInput ref={ref} {...p} />
	},
)

PasswordField.displayName = 'PasswordField'
